export type AccessRequirement = 'public' | 'guest' | 'signed_in' | 'keyra_verified';

export interface RouteDefinition {
  id: string;
  label: string;
  path: string;
  access: AccessRequirement;
  group: 'primary' | 'secondary' | 'utility';
  breadcrumb?: string;
}

export const ROUTES: RouteDefinition[] = [
  { id: 'explore', label: 'Explore', path: '/', access: 'public', group: 'primary', breadcrumb: 'Explore' },
  { id: 'search', label: 'Search', path: '/search', access: 'public', group: 'utility' },
  { id: 'create', label: 'Create', path: '/workspace', access: 'keyra_verified', group: 'primary' },
  { id: 'connect', label: 'Connect', path: '/connect', access: 'public', group: 'primary' },
  { id: 'library', label: 'My Library', path: '/library', access: 'signed_in', group: 'primary' },
  { id: 'upload', label: 'Upload', path: '/upload', access: 'keyra_verified', group: 'secondary' },
  { id: 'earn', label: 'Earn', path: '/earn', access: 'signed_in', group: 'secondary' },
  { id: 'about', label: 'About', path: '/about', access: 'public', group: 'secondary' },
  { id: 'design-system', label: 'Design system', path: '/design-system', access: 'public', group: 'utility' },
];

export const PRIMARY_NAV = ROUTES.filter((r) => r.group === 'primary');
export const SECONDARY_NAV = ROUTES.filter((r) => r.group === 'secondary');

export function findRoute(pathname: string): RouteDefinition | undefined {
  if (pathname.startsWith('/spin/')) return { id: 'spin', label: 'Object', path: pathname, access: 'public', group: 'utility' };
  if (pathname === '/create' || pathname.startsWith('/workspace')) {
    return ROUTES.find((r) => r.id === 'create');
  }
  return ROUTES.find((r) => r.path === pathname);
}

/** Allowlisted same-origin return paths after authentication. */
const RETURN_ALLOWLIST = new Set([
  '/',
  '/search',
  '/create',
  '/workspace',
  '/upload',
  '/library',
  '/connect',
  '/profile',
  '/settings/ai',
]);

export function sanitizeReturnPath(path: string): string {
  if (!path.startsWith('/') || path.startsWith('//')) return '/';
  const base = path.split('?')[0] ?? '/';
  if (
    RETURN_ALLOWLIST.has(base) ||
    base.startsWith('/spin/') ||
    base.startsWith('/publish/') ||
    base.startsWith('/refine/') ||
    base.startsWith('/checkout/') ||
    base.startsWith('/channel/') ||
    base.startsWith('/workspace')
  ) {
    return path;
  }
  return '/';
}
